/**
 * @fileoverview Atomized component that warns the channel integration was disconnected.
 * The chat becomes read-only: the history stays visible and internal notes are
 * still allowed, but the microservice rejects any send to the platform.
 * @module DisconnectedChannelMessageMC
 * @category Component - Atom
 * @since 1.0.0
 */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * DisconnectedChannelMessageMC - Disconnected channel notice in the inbox.
 */
const DisconnectedChannelMessageMC = memo(() => {
  const { t } = useTranslation('InboxMC');
  return (
    <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-4">
      <div className="tw-px-5 tw-text-sm tw-text-gray-950 tw-break-words tw-text-center">
        <p>{t('disconnected_channel_message')}</p>
      </div>
    </div>
  );
});

DisconnectedChannelMessageMC.displayName = 'DisconnectedChannelMessageMC';

export default DisconnectedChannelMessageMC;
